module.exports = __webpack_public_path__ + "static/media/ql-icon-brunch.8406521a.svg";